// 动漫网文章资讯数据
export interface Article {
  id: string;
  title: string;
  category: string;
  date: string;
  cover: string;
  summary: string;
  author: string;
  tags: string[];
  content: string[];
  relatedWorks: string[];
}

export const articles: Article[] = [
  {
    id: 'autumn-2026-preview',
    title: '2026 秋季新番前瞻：不容错过的 10 部动画',
    category: '新番前瞻',
    date: '2026-08-15',
    cover:
      'https://readdy.ai/api/search-image?query=Stylish%20anime%20illustration%20of%20multiple%20colorful%20anime%20characters%20lined%20up%20on%20a%20starry%20night%20sky%20with%20a%20growing%20crescent%20moon%20and%20fireworks%2C%20warm%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20key%20visual%2C%20festive%20anticipation&width=900&height=600&seq=art-autumn&orientation=landscape',
    summary: '秋季新番季正式拉开帷幕，从热血续作到原创黑马，这里为你整理本季最值得期待的 10 部动画，帮你提前锁定追番清单。',
    author: '动漫网编辑部',
    tags: ['新番', '盘点', '2026秋'],
    relatedWorks: ['frieren', 'rezero', 'chainsaw-man'],
    content: [
      '2026 年秋季新番季如约而至，各大制作委员会纷纷放出重磅企划。本季既有经典 IP 的续作回归，也不乏充满想象力的原创作品，堪称近年来最令人期待的一季。',
      '首先是万众期待的续作阵容。多部人气作品的第二、第三季将在本季播出，剧情将进入更为紧张的高潮阶段。无论是热血战斗还是细腻情感，都值得粉丝们守在屏幕前等待更新。',
      '原创动画同样是本季的一大看点。几家顶级动画工作室分别带来了全新的世界观企划，从科幻冒险到奇幻物语，题材覆盖广泛，画面表现力十足，有望成为新一批的现象级作品。',
      '对于想轻松追番的观众，本季同样准备了多部治愈系与搞笑系作品。忙碌的工作学习之余，这些轻松愉快的作品能帮你一扫疲惫，带来整季的欢乐时光。',
      '我们将在开播后持续更新每部作品的详细评价与观后感，欢迎收藏动漫网新番速递页面，第一时间掌握最权威的追番指南。',
    ],
  },
  {
    id: 'top-guochuang',
    title: '十大必看国漫推荐：从《灵笼》到《雾山五行》',
    category: '作品推荐',
    date: '2026-08-10',
    cover:
      'https://readdy.ai/api/search-image?query=Stylish%20anime%20illustration%20of%20chinese%20ink%20style%20heroes%20with%20red%20lanterns%20and%20dragons%20over%20ancient%20palaces%20under%20a%20dramatic%20warm%20sky%2C%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20key%20visual%2C%20cultural%20epic%20tone&width=900&height=600&seq=art-guochuang&orientation=landscape',
    summary: '国产动画近年迎来爆发，从科幻末世到水墨武侠，从修仙传奇到都市奇幻，十大必看国漫带你感受国漫崛起的魅力。',
    author: '动漫网编辑部',
    tags: ['国漫', '推荐', '盘点'],
    relatedWorks: ['ling-cage', 'link-click', 'wu-shan-wuxing', 'fanren', 'douluo'],
    content: [
      '近年来，国产动画在题材、制作与叙事上全面发力，涌现出一大批口碑与热度双丰收的佳作，国漫崛起早已不是一句空话。',
      '以《灵笼》为代表的科幻末世题材，凭借精良的 3D 制作与深刻的哲学思辨，向世界展示了国漫在宏大世界观构建上的野心。而《雾山五行》则以纯手绘的水墨画风，把动作戏做到了让海外观众惊呼的级别。',
      '在玄幻修仙领域，《凡人修仙传》《斗罗大陆》等作品将东方修仙文化推向更广的观众群，成为国漫中流砥柱。与此同时，都市奇幻《时光代理人》用扎实的剧情与细腻的情感打动了无数年轻观众。',
      '国漫的类型也愈发多元，热血、治愈、悬疑、恋爱百花齐放，创作生态日趋健康。越来越多的观众开始主动追更国产动画，其影响力正在持续扩大。',
      '如果你还没有认真追过国漫，不妨从这份清单开始，感受属于中国动画的独特魅力与骄傲。',
    ],
  },
  {
    id: 'shinkai-films',
    title: '新海诚动画盘点：每一帧都是壁纸级美景',
    category: '导演专题',
    date: '2026-08-05',
    cover:
      'https://readdy.ai/api/search-image?query=Stylish%20anime%20illustration%20of%20a%20glowing%20comet%20over%20a%20dreamy%20city%20skyline%20with%20soft%20clouds%20and%20starry%20sky%2C%20warm%20coral%20and%20gold%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20key%20visual%2C%20breathtaking%20cinematic%20sky&width=900&height=600&seq=art-shinkai&orientation=landscape',
    summary: '从《秒速五厘米》到《你的名字。》，新海诚用极致细腻的画面与触动人心的情感，构筑了一个又一个关于距离与羁绊的浪漫世界。',
    author: '动漫网编辑部',
    tags: ['新海诚', '电影', '盘点'],
    relatedWorks: ['your-name', 'natsume'],
    content: [
      '新海诚是当代最受瞩目的动画导演之一，他对于光影、云彩、星空等自然景物的细腻刻画，早已成为极具辨识度的个人标签。',
      '从早期作品《秒速五厘米》中樱花飘落的唯美场景，到《你的名字。》里彗星划破夜空的震撼瞬间，新海诚始终在探索"距离"与"羁绊"这两个永恒主题。',
      '在他的电影里，画面不仅服务于叙事，更承载着角色的情绪。细腻的光影变化、恰到好处的留白，都让观众在极致的视觉享受中，被故事缓缓打动。',
      '新海诚的作品在商业上也取得了巨大成功，《你的名字。》票房一度刷新日本动画电影纪录，证明了他独特的艺术风格同样具有强大的大众吸引力。',
      '对于喜爱高画质与细腻情感的观众而言，新海诚的每一部作品都值得反复观看，每一次都能发现新的感动。',
    ],
  },
  {
    id: 'hot-blooded-top10',
    title: '热血番 TOP10：燃到不行的经典之作',
    category: '作品推荐',
    date: '2026-07-28',
    cover:
      'https://readdy.ai/api/search-image?query=Stylish%20anime%20illustration%20of%20a%20group%20of%20fierce%20warriors%20with%20flaming%20energy%20auras%20charging%20into%20battle%20under%20a%20fiery%20warm%20sky%2C%20coral%20and%20gold%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20key%20visual%2C%20epic%20fighting%20spirit&width=900&height=600&seq=art-hotblood&orientation=landscape',
    summary: '热血番是无数动漫迷的入坑之选，本文为你盘点十部最能点燃斗志、让人热血沸腾的经典动画，献给每一个热爱战斗与羁绊的你。',
    author: '动漫网编辑部',
    tags: ['热血', 'TOP10', '经典'],
    relatedWorks: ['attack-on-titan', 'demon-slayer', 'one-piece', 'jujutsu-kaisen', 'chainsaw-man'],
    content: [
      '热血番之所以经久不衰，是因为它们讲述了关于成长、友情与坚持的动人故事，主角们在逆境中一次次突破自我的身影，总能引起观众深深的共鸣。',
      '从《进击的巨人》中为自由而战的热血抗争，到《鬼灭之刃》里炭治郎不放弃任何人的温柔坚毅，热血番用燃到极致的战斗场面，传递着最为朴素而炽热的情感。',
      '《海贼王》用二十年时间见证了一代人的青春，草帽一伙对梦想的执着，至今仍激励着无数观众。《咒术回战》与《电锯人》则以更强烈的视觉冲击，重新定义了现代热血番的表现力。',
      '热血并不仅限于战斗题材，《排球少年》《灌篮高手》等体育竞技作品同样以昂扬的斗志感染人心，展现了"燃"的另一种形态。',
      '无论你是刚入坑的新观众，还是追番多年的老粉，这份热血清单都值得反复品味。',
    ],
  },
  {
    id: 'healing-anime',
    title: '治愈系动漫推荐：温暖你整个冬天',
    category: '作品推荐',
    date: '2026-07-20',
    cover:
      'https://readdy.ai/api/search-image?query=Stylish%20anime%20illustration%20of%20a%20cozy%20cottage%20with%20warm%20light%20in%20a%20snowy%20quiet%20village%20with%20soft%20falling%20snow%20and%20warm%20teacup%2C%20coral%20and%20gold%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20key%20visual%2C%20tranquil%20heartwarming%20winter&width=900&height=600&seq=art-healing&orientation=landscape',
    summary: '当生活变得疲惫，治愈系动漫是最好的避风港。本文推荐多部温暖人心的作品，用温柔的故事抚慰你的心灵。',
    author: '动漫网编辑部',
    tags: ['治愈', '推荐', '温馨'],
    relatedWorks: ['natsume', 'frieren', 'spy-family', 'your-name'],
    content: [
      '在快节奏的现代生活中，治愈系动漫以其温柔细腻的叙事，成为无数人心灵的避风港，陪伴他们度过一个又一个疲惫的夜晚。',
      '《夏目友人帐》用一个个关于妖怪与人的温柔故事，讲述了孤独与陪伴的珍贵；而《葬送的芙莉莲》则以充满哲思的漫长旅程，探讨了生命、回忆与羁绊的深刻主题。',
      '治愈系并不一定需要宏大的世界观，往往一个温馨的日常、一句恰到好处的鼓励，就足以让人眼眶发热。《间谍过家家》用爆笑又温暖的家庭日常，让人在欢笑中感受到家的温度。',
      '冬日的夜晚，一杯热茶，一部治愈系动画，便是最简单的幸福。希望这些作品能给你带来片刻的安宁与温暖。',
    ],
  },
  {
    id: 'isekai-trend',
    title: '异世界转生题材为何长盛不衰',
    category: '深度解读',
    date: '2026-07-12',
    cover:
      'https://readdy.ai/api/search-image?query=Stylish%20anime%20illustration%20of%20a%20gateway%20portal%20opening%20between%20a%20modern%20city%20and%20a%20fantasy%20world%20with%20castles%20and%20dragons%2C%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20key%20visual%2C%20fascinating%20transition%20tone&width=900&height=600&seq=art-isekai&orientation=landscape',
    summary: '从《Re:Zero》到《从零开始的魔法书》，异世界转生题材持续霸屏。本文深入剖析这一题材火爆背后的创作逻辑与观众心理。',
    author: '动漫网编辑部',
    tags: ['异世界', '深度', '解读'],
    relatedWorks: ['rezero', 'oshi-no-ko'],
    content: [
      '近十年来，异世界转生题材几乎成为日本轻小说与动画市场最热门的创作方向，源源不断的作品涌入，却依然保持着旺盛的生命力。',
      '这一题材的火爆，与它强大的"代入感"密不可分。主角往往是从现代生活"穿越"过去的普通人，观众能够轻易地将自己代入其中，体验一场摆脱现实束缚、重新开始的人生。',
      '同时，异世界为创作者提供了极为自由的发挥空间。魔法、种族、冒险、恋爱、建城……丰富的元素可以任意组合，满足不同观众的喜好，也催生了大量各具特色的细分类型。',
      '当然，题材的红海也带来了同质化的问题。真正能脱颖而出的，往往是那些在设定或人物塑造上有所创新的作品，如《Re:Zero》将轮回与痛苦融入其中，带来了更深层的情感冲击。',
      '可以预见，异世界题材仍将在未来持续发光，但只有真诚用心的作品，才能真正赢得观众的长久喜爱。',
    ],
  },
];

export function findArticleById(id: string): Article | undefined {
  return articles.find((a) => a.id === id);
}